import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { SystemEventSource } from '@/hooks/useSystemEvents';

interface SystemEventSourceBadgeProps {
  source: SystemEventSource;
  className?: string;
}

const sourceConfig: Record<SystemEventSource, {
  label: string;
  className: string;
}> = {
  ui: {
    label: 'UI',
    className: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400',
  },
  edge: {
    label: 'Edge',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  },
  db: {
    label: 'DB',
    className: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400',
  },
  cron: {
    label: 'Cron',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
  },
};

export function SystemEventSourceBadge({ source, className }: SystemEventSourceBadgeProps) {
  const config = sourceConfig[source] || sourceConfig.ui;

  return (
    <Badge 
      variant="outline"
      className={cn(
        'font-mono text-xs',
        config.className,
        className
      )}
    >
      {config.label}
    </Badge>
  );
}
